import { useParams, Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import LoginPoolSection from '_/common/components/layout/LoginPoolSection';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import { useLoginPools } from '_/hooks/useLoginPools';
import { IEditLoginPoolPageParams } from '_/types/loginPools';
import React, { ReactElement } from 'react';

function SelectedLoginPoolContent(): ReactElement {
  const { selectedOrgSlug: orgSlug } = useOrganization();
  const { selectedProject, selectedProjectSlug: projectSlug } = useProject();
  const params = useParams({ strict: false }) as Partial<IEditLoginPoolPageParams>;
  const loginPoolSlug = params.loginPoolSlug || '';

  // Fetch login pools to determine loading state (must be before conditional returns)
  const { isLoading } = useLoginPools(selectedProject?.id, orgSlug, projectSlug);

  // Don't render anything for special route slugs
  if (loginPoolSlug === '_new') {
    return <></>;
  }

  return (
    <AsyncPageContainer isLoading={isLoading}>
      <Outlet />
    </AsyncPageContainer>
  );
}

const SelectedLoginPool = (): ReactElement => {
  return (
    <LoginPoolSection>
      <SelectedLoginPoolContent />
    </LoginPoolSection>
  );
};

export default SelectedLoginPool;
